import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Shield, Cpu } from 'lucide-react';
import ai_image from '../../assets/images/ai-image.jpg'
import scale_out from '../../assets/images/scale.png'
import hybrid_image from '../../assets/images/llm.jpg'
const FeaturesSection = () => {
  const features = [
    {
      
      title: "Streamlined Scaling for Data Model Training",
      description: "aiDAPTIV+ is the ultimate turnkey solution for organizations to train large data models without additional staff and infrastructure. The platform scales linearly with your data training and time requirements, allowing you to focus on results.",
      imageSrc: ai_image,
      alt: "Performance visualization"
    },
    {
      
      title: "Scale out",
      description: "aiDAPTIV+ allows businesses to efficiently scale computational nodes, enhancing their capacity to handle larger models and datasets and speeding up the training process.",
      imageSrc: scale_out,
      alt: "Memory efficiency diagram"
    },
    {
      
      title: "Hybrid Solution Boosts LLM Training Efficiency",
      description: "MiPhi’s aiDAPTIV+ is a hybrid software / hardware solution for today’s biggest challenges in LLM training.A single local workstation PC from one of our partners provides a cost-effective approach to LLM training, up to Llama 70b.",
      imageSrc: hybrid_image,
      alt: "Scalability illustration"
    }
  ];
  
  return (
    <div className="mt-16 space-y-24 bg-black">
      {features.map((feature, index) => (
        <motion.div
          key={feature.title}
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: index * 0.2 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-2 gap-8 items-center"
        >
          <div className={`space-y-6 ${index % 2 === 1 ? 'md:order-2' : ''}`}>
            <div className="backdrop-blur-xl bg-white/5 rounded-xl p-6 border border-white/10 transition-all duration-300">
              {feature.icon}
              <h3 className="text-2xl font-semibold text-gray-100 mt-6">
                {feature.title}
              </h3>
              <p className="text-gray-400 mt-4 leading-relaxed">
                {feature.description}
              </p>
            </div>
          </div>
          <div className={index % 2 === 1 ? 'md:order-1' : ''}>
            <div className="bg-gray-900/50 backdrop-blur-xl rounded-xl p-4 border border-gray-800 shadow-lg hover:bg-gray-900/70 transition-all duration-300">
              <img
                src={feature.imageSrc}
                alt={feature.alt}
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </motion.div>
      ))}
      <br></br><br></br>
    </div>
  );
};

export default FeaturesSection;